// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../../../../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";

function AllocationUserPrompt(Props) {
  var modal_data = Props.modal_data;
  return React.createElement(ConfirmationModal.make, {
              title: modal_data.title,
              isOpen: modal_data.isOpen,
              onConfirmCb: modal_data.onSubmit,
              onCancelCb: modal_data.onCancel,
              confirm_button_title: modal_data.confirm_button_title,
              cancel_button_title: modal_data.cancel_button_title,
              children: modal_data.modal_body
            });
}

var make = AllocationUserPrompt;

export {
  make ,
  
}
/* react Not a pure module */
